export const login = {
  title: 'ログイン',
  loginId: 'ユーザー名',
  password: 'パスワード',
};
